"use client"
import { usePathname, useRouter } from "next/navigation"
import { useEffect } from "react"
import { useUser } from "@lib/api/user"

export function ApplicationAuthLock() {
    const pathname = usePathname()
    const { isLoading, isAuthenticated } = useUser()
    const router = useRouter()

    useEffect(() => {
        const isApp = localStorage.getItem("isApp") === "1"
        if (isApp && !isAuthenticated && !isLoading && pathname !== "/application-auth") {
            router.replace("/application-auth")
        }
    }, [pathname, router, isAuthenticated, isLoading])
    useEffect(() => {
        if (isAuthenticated && !isLoading && pathname === "/application-auth") {
            router.replace("/listings")
        }
    }, [pathname, isAuthenticated, isLoading, router])
    return null
}
